import { Fragment } from "react";
import { type PropsWithChildren } from "react";
import { GridLegacy as Grid, IconButton } from "@mui/material";

interface IconProps {
    label: string;
    onClick: () => void
}

const Icon = (props: PropsWithChildren<IconProps>) => {
    if (props.label == "") {
        return <Fragment>{props.children}</Fragment>;
    }
    return (
        <Grid item xs={12} sm={2}>
            <IconButton title={props.label} onClick={props.onClick}>
                {props.children}
            </IconButton>
        </Grid>
    );
};

export default Icon;
